import { jsx as _jsx } from "react/jsx-runtime";
import { Column, Columns } from '@dixa/lib-shared-habla';
import { AnalyticsFilterLayoutEmpty } from './components/empty/analyticsFilterLayoutEmpty';
import { AnalyticsFilterLayoutLoading } from './components/loading/analyticsFilterLayoutLoading';
import { AnalyticsFilterLayoutRow } from './components/row/analyticsFilterLayoutRow';
export const AnalyticsFilterLayout = ({ children, }) => (_jsx(Columns, { children: _jsx(Column, Object.assign({ size: "300px" }, { children: children })) }));
AnalyticsFilterLayout.Row = AnalyticsFilterLayoutRow;
AnalyticsFilterLayout.Empty = AnalyticsFilterLayoutEmpty;
AnalyticsFilterLayout.Loading = AnalyticsFilterLayoutLoading;
